export enum StatisticalAnalysisViewDetailTabView {
    TABLE = 0,
    CHART = 1
}

export interface StatisticalAnalysisViewDetailState {
    tabIndex: StatisticalAnalysisViewDetailTabView
    caseListWindowsReference: any
    groupingLoaded: boolean
}
export const initialStatisticalAnalysisViewDetailState =
    (): StatisticalAnalysisViewDetailState => ({
        tabIndex: StatisticalAnalysisViewDetailTabView.TABLE,
        caseListWindowsReference: null,
        groupingLoaded: false
    })
